module.exports = __webpack_public_path__ + "media/esophageal dysplasia.f2f22082.wav";